export class BenutzerInfoSearchApiDto {
    constructor() {
        this.userSignInEmail = '';
    }
    userSignInEmail: string;
}
